/**
 * Second half of the native guard (see floorNativeGuard.ts): imported by
 * floorPolyfills.generated.ts AFTER every core-js entry, so each native a
 * current browser shipped is back in place before any app code runs.
 */
import { BEFORE_CORE_JS, restoreGuardedNatives } from '@/lib/floorNativeGuard';

restoreGuardedNatives(BEFORE_CORE_JS);
